@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.adata?.fetch_key) {
    @let prefix = $.adata.fetch_key;
    @let fullName = $.row[prefix + '_clt_full_name'];
    @let clientId = $.row[prefix + '_clt_id'];
    @let image = $.row[prefix + '_clt_image'];
    @let phone = $.row[prefix + '_clt_mobile_no'];
    @let countryCode = $.row[prefix + '_clt_mobile_country_code'];
    @let email = $.row[prefix + '_clt_emailid'];

    <!-- Popover -->
    <p-popover
      #op
      styleClass="overflow-hidden text-sm"
      appendTo="body"
      [dismissable]="true"
    >
      <ng-template #content>
        <!-- Popover Header -->
        <div
          class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2"
        >
          <div class="w-10rem line-height-1">
            <div
              class="text-sm font-medium text-800"
              [attr.data-testid]="'client-info-report-name'"
            >
              {{ fullName | titlecase }}
            </div>
            @if (!isEmptyOrNull(clientId)) {
              <div
                class="text-xs text-600 mt-1"
                [attr.data-testid]="'client-info-report-id'"
              >
                {{ clientId }}
              </div>
            }
          </div>
        </div>
        <!-- Popover Header -->

        <!-- Popover Footer -->
        <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs">
          <div class="flex align-items-center mb-2">
            <i class="fa fa-phone mr-2 text-500"></i>
            @if (!isEmptyOrNull(phone)) {
              <span [attr.data-testid]="'client-info-report-phone'">
                {{ countryCode }}{{ phone }}
              </span>
            } @else {
              <span>NA</span>
            }
          </div>
          <div class="flex align-items-center mb-1">
            <i class="fa fa-envelope font-light mr-2 text-500"></i>
            @if (!isEmptyOrNull(email)) {
              <span
                class="break-word"
                [attr.data-testid]="'client-info-report-email'"
              >
                {{ email }}
              </span>
            } @else {
              <span>NA</span>
            }
          </div>
        </div>
        <!-- Popover Footer -->
      </ng-template>
    </p-popover>
    <!-- Popover -->

    <!-- Cell -->
    @if (!isEmptyOrNull(fullName)) {
      <div
        class="flex align-items-center cursor-pointer"
        (mouseenter)="show($event)"
        (mouseleave)="hide()"
        (click)="gotoClient(clientId)"
        [attr.data-testid]="'client-info-report-cell'"
      >
        @if (!isEmptyOrNull(image)) {
          <p-avatar
            [image]="image"
            shape="circle"
            styleClass="mr-2 overflow-hidden"
            [attr.data-testid]="'client-info-report-avatar-img'"
          />
        } @else {
          <p-avatar
            [label]="fullName | titlecase | shortName"
            shape="circle"
            styleClass="text-sm mr-2"
            [attr.data-testid]="'client-info-report-avatar-initials'"
          />
        }
        <span
          class="text-primary text-sm font-bold"
          [attr.data-testid]="'client-info-report-fullname'"
        >
          {{ fullName | titlecase }}
        </span>
      </div>
    } @else {
      <span [attr.data-testid]="'client-info-report-empty'">-</span>
    }
    <!-- Cell -->
  }
}
